// import { useI18n } from "vue-i18n";
// const locale = useI18n();
// console.log("locale",locale.locale.value)

// EN_US("en_US", "English"),
// ZH_HK("zh_HK", "中文繁体"),
// ZH_CN("zh_CN", "中文简体");

// 方法一：item中统一nameCn, nameEn, nameHk,简体，英文，繁体的，则直接传
export const setLabelNameItem = (item: any) => {
  if (item) {
    const language = localStorage.getItem("locale") || "zh_CN";
    return language === "en_US"
      ? item.nameEn
      : language === "zh_HK"
      ? item.nameHk
      : language === "es_ES"
      ? item.nameEs
      : item.nameCn;
  }
  return "";
};

// 方法二：不确定简体，英文，繁体的，则按顺序传对应的
export const setLabelNameArr = (nameCn: string, nameEn: string, nameHk: string, nameEs: string) => {
  const language = localStorage.getItem("locale") || "zh_CN";
  const name =
    language === "en_US"
      ? nameEn
      : language === "zh_HK"
      ? nameHk
      : language === "es_ES"
      ? nameEs
      : nameCn;
  return name;
};

export const getLabelNameItem = (key: any, value: any, list: any = []) => {
  if (key && value) {
    const item = list.find((it: any) => it[key] == value);
    return item ? setLabelNameItem(item) : null;
  }
  return null;
};
